<template>
  <div class="ui-datepicker">
    <ui-input
      clearable
      ref="input"
      v-model="localValue"
      :label="label"
      :required="required"
      placeholder="дд.мм.гггг"
      autocomplete="off"
      mask="date"
      :validate="validate"
      @blur="onBlur"
    />
  </div>
</template>

<script>

export default {
  name: 'ui-datepicker',
  props: {
    value: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: 'Дата',
    },
    outputFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    validate: {
      type: String,
      default: 'date'
    }
  },

  data: () => ({
    localValue: '',
  }),

  watch: { // покрывает кейс, когда при удалении ребенка из формы не обновляется localValue
    value(val) {
      const [d, m, y] = this.parseDate(val);
      this.localValue = `${d}.${m}.${y}`;
    }
  },

  created() {
    const [d, m, y] = this.parseDate(this.value);
    this.localValue = `${d}.${m}.${y}`;
  },
  methods: {
    parseDate(v = this.localValue) { // на выход [d, m, y]
      if (v.split('.').length === 3) { // 15.05.1995
        return v.split('.');
      } else if (v.split('-').length === 3) { // "1995-05-15"
        const [y, m, d] = v.split('-');
        return [d, m, y];
      }
      // добавить другие встречающиеся форматы
      return [];
    },
    outputDate([d, m, y]) {
      return this.outputFormat
        .replace('YYYY', y)
        .replace('MM', m)
        .replace('DD', d)
      ;
    },
    onBlur() {
      if (!this.$refs.input.valid) return;
      this.$emit('input', this.outputDate(this.parseDate()));
    },
  },
}
</script>
